import React, { useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './CommonStyles.css';
import './AllSellStyles.css';
import './NotificationTemplates.css'; // Import the new CSS file

const tagsData = {
  ledger: [
    '{business_name}', '{business_logo}', '{balance_due}', '{contact_name}',
    '{contact_custom_field_1}', '{contact_custom_field_2}', '{contact_custom_field_3}',
    '{contact_custom_field_4}', '{contact_custom_field_5}', '{contact_custom_field_6}',
    '{contact_custom_field_7}', '{contact_custom_field_8}', '{contact_custom_field_9}',
    '{contact_custom_field_10}'
  ],
  customer: [
    '{business_name}', '{business_logo}', '{invoice_number}', '{invoice_url}',
    '{total_amount}', '{paid_amount}', '{due_amount}', '{cumulative_due_amount}', '{due_date}',
    '{location_name}', '{location_address}', '{location_email}', '{location_phone}',
    '{location_custom_field_1}', '{location_custom_field_2}', '{location_custom_field_3}', '{location_custom_field_4}',
    '{contact_name}', '{contact_custom_field_1}', '{contact_custom_field_2}', '{contact_custom_field_3}',
    '{contact_custom_field_4}', '{contact_custom_field_5}', '{contact_custom_field_6}', '{contact_custom_field_7}',
    '{contact_custom_field_8}', '{contact_custom_field_9}', '{contact_custom_field_10}',
    '{sell_custom_field_1}', '{sell_custom_field_2}', '{sell_custom_field_3}', '{sell_custom_field_4}',
    '{shipping_custom_field_1}', '{shipping_custom_field_2}', '{shipping_custom_field_3}', '{shipping_custom_field_4}', '{shipping_custom_field_5}'
  ],
  supplier: [
    '{business_name}', '{business_logo}', '{order_ref_number}', '{total_amount}', '{received_amount}', '{due_amount}',
    '{location_name}', '{location_address}', '{location_email}', '{location_phone}',
    '{location_custom_field_1}', '{location_custom_field_2}', '{location_custom_field_3}', '{location_custom_field_4}',
    '{purchase_custom_field_1}', '{purchase_custom_field_2}', '{purchase_custom_field_3}', '{purchase_custom_field_4}', '{contact_business_name}',
    '{contact_name}', '{contact_custom_field_1}', '{contact_custom_field_2}', '{contact_custom_field_3}',
    '{contact_custom_field_4}', '{contact_custom_field_5}', '{contact_custom_field_6}', '{contact_custom_field_7}',
    '{contact_custom_field_8}', '{contact_custom_field_9}', '{contact_custom_field_10}',
    '{shipping_custom_field_1}', '{shipping_custom_field_2}', '{shipping_custom_field_3}', '{shipping_custom_field_4}', '{shipping_custom_field_5}'
  ]
};

const TemplateEditor = ({ tagsGroup, defSubject, defSms, showAutoSend = true }) => {
  const [emailBody, setEmailBody] = useState('<p></p>');
  const [subject, setSubject] = useState(defSubject || 'Email Subject');
  const [cc, setCc] = useState('');
  const [bcc, setBcc] = useState('');
  const [sms, setSms] = useState(defSms || '');
  const [whatsapp, setWhatsapp] = useState('');

  const [autoEmail, setAutoEmail] = useState(false);
  const [autoSms, setAutoSms] = useState(false);
  const [autoWhatsapp, setAutoWhatsapp] = useState(false);

  // When the defSubject or defSms props change (tab switches), update the state
  React.useEffect(() => {
    setSubject(defSubject || 'Email Subject');
    setSms(defSms || '');
  }, [defSubject, defSms]);

  return (
    <div className="notification-content">

      {/* Tags Section */}
      <div className="editor-tags-section">
        <h4 className="editor-tags-title">Available Tags:</h4>
        <div className="editor-tags-list">
          {tagsData[tagsGroup].map((tag, i) => (
            <span key={i} className="editor-tag-pill">
              {tag}
            </span>
          ))}
        </div>
        <p className="editor-tags-hint">
          Business logo will not work in SMS
        </p>
      </div>

      {/* Form Fields */}
      <div className="editor-form-grid">

        <div className="editor-form-group">
          <label className="editor-label">Email Subject:*</label>
          <input
            type="text"
            className="editor-input"
            value={subject}
            onChange={e => setSubject(e.target.value)}
          />
        </div>

        <div className="editor-form-group">
          <label className="editor-label">CC:</label>
          <input
            type="text"
            className="editor-input"
            value={cc}
            onChange={e => setCc(e.target.value)}
            placeholder="CC"
          />
        </div>

        <div className="editor-form-group">
          <label className="editor-label">BCC:</label>
          <input
            type="text"
            className="editor-input"
            value={bcc}
            onChange={e => setBcc(e.target.value)}
            placeholder="BCC"
          />
        </div>

        {/* Rich Text Editor */}
        <div className="editor-form-group quill-container">
          <label className="editor-label">Email Body:*</label>
          <ReactQuill
            theme="snow"
            value={emailBody}
            onChange={setEmailBody}
            modules={{
              toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ['link', 'image'],
                ['clean']
              ]
            }}
          />
        </div>

        <div className="editor-form-group">
          <label className="editor-label">SMS Body:*</label>
          <textarea
            className="editor-textarea"
            value={sms}
            onChange={e => setSms(e.target.value)}
            rows={4}
          />
        </div>

        <div className="editor-form-group">
          <label className="editor-label">Whatsapp Text:</label>
          <textarea
            className="editor-textarea"
            value={whatsapp}
            onChange={e => setWhatsapp(e.target.value)}
            placeholder="Whatsapp Text"
            rows={4}
          />
        </div>

        {/* Auto Send Toggles */}
        {showAutoSend && (
          <div className="auto-send-section">
            <label className="auto-send-label">
              <input type="checkbox" className="auto-send-checkbox" checked={autoEmail} onChange={e => setAutoEmail(e.target.checked)} />
              Auto Send Email
            </label>
            <label className="auto-send-label">
              <input type="checkbox" className="auto-send-checkbox" checked={autoSms} onChange={e => setAutoSms(e.target.checked)} />
              Auto Send SMS
            </label>
            <label className="auto-send-label">
              <input type="checkbox" className="auto-send-checkbox" checked={autoWhatsapp} onChange={e => setAutoWhatsapp(e.target.checked)} />
              Auto send Whatsapp notification
            </label>
          </div>
        )}

        {showAutoSend && Object.keys(tagsData).find(k => tagsGroup === k) && (
          <p className="auto-send-hint">
            If enabled, notification will be automatically sent to {tagsGroup === 'supplier' ? 'supplier' : 'customer'} on creating new {tagsGroup === 'supplier' ? 'orders' : 'sales'} for them
          </p>
        )}

        {/* Action Button */}
        <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'center' }}>
          <button className="editor-save-btn" onClick={() => alert(`Saved template for ${defSubject}`)}>
            Save
          </button>
        </div>

      </div>
    </div>
  );
};

const NotificationTemplates = () => {
  const [activeTab, setActiveTab] = useState('notifications');
  const [activeSubTab, setActiveSubTab] = useState('send-ledger');

  // Definitions for Top Level Tabs
  const topTabs = [
    { id: 'notifications', label: 'Notifications' },
    { id: 'customer', label: 'Customer Notifications' },
    { id: 'supplier', label: 'Supplier Notifications' }
  ];

  // Definitions for Sub-Tabs within their respective categories
  const subTabsMap = {
    'notifications': [
      { id: 'send-ledger', label: 'Send Ledger', comp: <TemplateEditor tagsGroup="ledger" defSubject="Email Subject" /> }
    ],
    'customer': [
      { id: 'new-sale', label: 'New Sale', comp: <TemplateEditor tagsGroup="customer" defSubject="Thank you from {business_name}" defSms="Dear {contact_name}, Thank you for shopping with us. {business_name}" /> },
      { id: 'payment-received', label: 'Payment Received', comp: <TemplateEditor tagsGroup="customer" defSubject="Payment Received" /> },
      { id: 'payment-reminder', label: 'Payment Remider', comp: <TemplateEditor tagsGroup="customer" defSubject="Payment Reminder" /> },
      { id: 'new-booking', label: 'New Booking', comp: <TemplateEditor tagsGroup="customer" defSubject="New Booking" /> },
      { id: 'new-quotation', label: 'New Quotation', comp: <TemplateEditor tagsGroup="customer" defSubject="New Quotation" /> }
    ],
    'supplier': [
      { id: 'new-order', label: 'New Order', comp: <TemplateEditor tagsGroup="supplier" defSubject="New Order, from {business_name}" defSms="Dear {contact_name}, We have a new order with reference number {order_ref_number}. Kindly process the products as soon as possible. {business_name}" /> },
      { id: 'payment-paid', label: 'Payment Paid', comp: <TemplateEditor tagsGroup="supplier" defSubject="Payment Paid" /> },
      { id: 'items-received', label: 'Items Received', comp: <TemplateEditor tagsGroup="supplier" defSubject="Items Received" /> },
      { id: 'items-pending', label: 'Items Pending', comp: <TemplateEditor tagsGroup="supplier" defSubject="Items Pending" /> },
      { id: 'purchase-order', label: 'Purchase Order', comp: <TemplateEditor tagsGroup="supplier" defSubject="Purchase Order" /> }
    ]
  };

  // Synchronize top tab switches to auto-select the first sub-tab
  const handleTopTabChange = (tabId) => {
    setActiveTab(tabId);
    setActiveSubTab(subTabsMap[tabId][0].id);
  };

  const currentSubTabs = subTabsMap[activeTab];
  const renderedComponent = currentSubTabs.find(t => t.id === activeSubTab)?.comp || null;

  return (
    <div className="notification-templates-container">

      <div className="notification-layout">

        {/* Top Primary Tabs */}
        <div className="notification-top-tabs">
          {topTabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => handleTopTabChange(tab.id)}
              className={`notification-top-tab ${activeTab === tab.id ? 'active' : ''}`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="notification-body">

          {/* Left Sub-Tabs Navigation */}
          <div className="notification-sidebar">
            {currentSubTabs.map(subTab => (
              <button
                key={subTab.id}
                onClick={() => setActiveSubTab(subTab.id)}
                className={`notification-sidebar-btn ${activeSubTab === subTab.id ? 'active' : ''}`}
              >
                {subTab.label}
              </button>
            ))}
          </div>

          {/* Right Content Area */}
          {renderedComponent}

        </div>

      </div>
    </div>
  );
};

export default NotificationTemplates;
